import Vue from "vue";
import VueRouter from "vue-router";
import { kee } from "@/keecloak";
import i18n from "@/i18n";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "references"
  },
  {
    name: "references",
    path: "/references",
    component: () => import("@/views/References.vue"),
    props: route => ({
      disableSearchAndFilter: route.meta.disableSearchAndFilter || false
    }),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        name: "gallery",
        path: "gallery",
        alias: [""],
        component: () => import("@/views/references/Gallery.vue")
      },
      {
        name: "map",
        path: "map",
        component: () => import("@/views/references/Map.vue")
      },
      {
        name: "list",
        path: "list",
        component: () => import("@/views/references/List.vue")
      },
      {
        name: "stats",
        path: "stats",
        component: () => import("@/views/references/Stats.vue"),
        meta: {
          disableSearchAndFilter: true
        }
      }
    ]
  },
  {
    name: "new",
    path: "/references/new",
    component: () => import("@/views/ReferenceEdit.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/references/:id/edit",
    component: () => import("@/views/ReferenceEdit.vue"),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  {
    name: "reference",
    path: "/references/:id",
    component: () => import("@/views/Reference.vue"),
    props: true,
    meta: {
      requiresAuth: true,
    },
  },
  ...(process.env.NODE_ENV == "development"
    ? [
        {
          path: "/component-test",
          component: () => import("@/views/ComponentTest.vue"),
          props: true,
        },
      ]
    : []),
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  linkActiveClass: "active",
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!kee.authenticated) {
      kee.login().then(() => next());
    } else {
      i18n.locale = kee.userInfo.locale;
      next();
    }
  } else {
    next();
  }
});

export default router;
